import Model from "../model";
import request from "../../request/request";
import { Param } from "../exambuilder/exam-v2"; //登记信息
import Auth from "@/lib/common/auth";
import { CompanyConfig } from "@/lib/common/acm";

export class SingleChoice extends Model {
  dimensionName = ""; // 维度名
  questionNumber = 0; // 抽题数
  questionScore = 0; // 单题分数
  count = 0;
}
export class VideoItem extends Model {
  dimensionName = ""; // 维度名
  questionIdList: number[] = [0]; // 题目id列表
}

export class ErrorRule extends Model {
  keyName = ""; // 登记信息名
  errorRule = 0; // 异常规则 0仅收集 1选中时未通过 2未选时未通过
}
export class UseRule extends Model {
  keyName = ""; // 登记信息-选项名
  useLevel = 0; // 使用级别 0 123  不考察 核心重点一般
  useSort = 0; // 使用排序
}
export class QuestionP extends Model {
  count = 0;
  dimensionDesc = "";
  dimensionName = "";
  questionNumber = 0;
  questionScore = 0;
  isStdDimension = 0;
}

//关注项配置
export class HeaderOption extends Model {
  // EnumHeaderOptionTypeDepressive           EnumHeaderOptionType = "抑郁自杀倾向"   // 心理测评-抑郁 非友达光电
  // EnumHeaderOptionTypeViolent              EnumHeaderOptionType = "暴力反社会倾向"  // 心理测评-暴力 非友达光电
  // EnumHeaderOptionTypeYdgdJsb              EnumHeaderOptionType = "精神病性"     // 心理测评-精神病 友达光电
  // EnumHeaderOptionTypeYdgdCd               EnumHeaderOptionType = "冲动和破坏性行为" // 心理测评-冲动 友达光电
  // EnumHeaderOptionTypeYdgdSh               EnumHeaderOptionType = "说谎性"      // 心理测评-说谎 友达光电
  // EnumHeaderOptionTypeBgCheckSocialInfo    EnumHeaderOptionType = "负面社会安全记录" // 背调-犯罪
  // EnumHeaderOptionTypeBgCheckFinancialRisk EnumHeaderOptionType = "金融黑名单"    // 背调-金融
  // EnumHeaderOptionTypeLr                   EnumHeaderOptionType = "身份认证"     // 排照片-比对身份证号
  // EnumHeaderOptionTypeReplacePersonCheck   EnumHeaderOptionType = "换人检测"     // 单选题-心理测评题-视频题 图片比对
  // EnumHeaderOptionTypeBgCheckIdentityInfo  EnumHeaderOptionType = "手机号实名认证"  // 背调-身份认证
  // EnumHeaderOptionTypeArmCheck             EnumHeaderOptionType = "手掌手臂检测"   // 手臂检测题
  // EnumHeaderOptionTypeBodyCheck            EnumHeaderOptionType = "纹身疤痕检测"   // 形体检测题
  // EnumHeaderOptionTypeColorCheck           EnumHeaderOptionType = "辨色检测"     // 色盲题
  // EnumHeaderOptionTypeChoice               EnumHeaderOptionType = "文化考试测试"   // 单选题
  // EnumHeaderOptionTypeVideoFace            EnumHeaderOptionType = "形象素质"     // 视频题
  // EnumHeaderOptionTypeVideoIse             EnumHeaderOptionType = "沟通表达"     // 视频题
  // EnumHeaderOptionTypeGame                 EnumHeaderOptionType = "认知能力"     // 打气球
  // EnumHeaderOptionTypeParamJob             EnumHeaderOptionType = "岗位要求"     // 登记信息
  // EnumHeaderOptionTypeParamAge             EnumHeaderOptionType = "年龄要求"     // 登记信息
  // EnumHeaderOptionTypeParamNation          EnumHeaderOptionType = "民族"       // 登记信息
  // EnumHeaderOptionTypeParamChoice          EnumHeaderOptionType = "通用单选"     // 登记信息
  // EnumHeaderOptionTypeParamMultiChoice     EnumHeaderOptionType = "通用多选"     // 登记信息
  type = ""; // 类型
  pType = ""; //父类型
  sType = ""; //多选 使用的选项名
  // 文化考试
  singleChoiceList: SingleChoice[] = [new SingleChoice()];
  // 沟通表达/形象素质
  videoList: VideoItem[] = [new VideoItem()];
  // 年龄要求
  ageRange: number[] = [0, 0];
  // 岗位要求/民族/通用单选/通用多选
  param = new Param();
  // 登记信息异常规则
  paramErrorRuleList: ErrorRule[] = [new ErrorRule()];
  // 登记信息使用规则
  paramUseRuleList: UseRule[] = [new UseRule()];
  // 非单选多选
  useLevel = 0; // 使用级别 0 123
  useSort = 0; // 使用排序
  videoQuestionIdList: number[] = [0]; //已选视频题id
  videoJudgeScore = 60; //通用视频  分数线
  optionName = ""; //单选多选用
  optionDescription = ""; //长描述
  optionDesc = ""; //短描述
  edit = false; //是否可编辑
  singleChoiceJudgeType = 0; //文化考试判分规则 0 60分 1 维度0分
  colorJudgeType = 0; //色盲检测 判分规则 后台用
  defaultMulti = 0; //是否系统自带多选类型（此类型在第二步 不需生成对应登记信息字段） 1是
}

//普工版 面试结构
export class ExamV3 extends Model {
  userId = 0; // 用户id
  companyId = 0; // 公司id
  examId = 0; // 面试id
  connectCode = ""; // 链接码
  // 基本信息
  name = ""; // 面试名称
  remark = ""; // 面试备注
  // publicityPageVideoStatus = 0; // 宣传页视频转码状态
  // 系统参数
  examType = ""; // 面试类型 aiworker
  isCandidateUsed = 0; // 是否存在候选人信息 1有

  //**************面试设置***
  // // 登记信息
  paramList: Param[] = [new Param()]; // 登记信息 与aibuilder一致
  captchaCheck = 2; // 校验验证码 1开
  // // 时间设置
  noEnding = 1; // 是否长期有效 默认1是
  beginTime = ""; // 面试开始时间
  endTime = ""; // 面试结束时间
  timeLimitGiveUp = -1; // 面试邀请有效期 -1不设置  秒
  giveUpSignIn = 1; //已签到是否自动过期(新增)
  giveUpNotSignIn = 1; // 未签到是否自动过期(新增)
  // // 宣传页设置
  publicityPageContent = ""; // 宣传介绍富文本  岗位描述
  publicityPageVideoId = ""; // 宣传介绍视频aiyunVideoId
  publicityPageVideoUrl = ""; //宣传介绍视频优先使用videoUrl 使用优先级高于videoId (用于设置默认视频/或者自定义上传后续的修改场景)
  publicityPageVideoUse = 2; // 宣传介绍视频是否使用 1开  废弃
  publicityPageVideoUseWhich = 0; //视频使用 0不使用 1默认视频 2自定义视频
  publicityPageVideoCoverUrl = ""; // 宣传介绍图片链接 默认的或者上传的
  publicityPageVideoCoverUse = 1; // 宣传介绍图片否使用 1开 目前必须开
  // // 面试引导语设置
  descBefore = ""; // 面试须知语富文本
  descAfter = ""; // 面试结束语富文本
  // // 重复面试限制
  repeatAnswer = 1; // 是否允许重复作答 012
  // repeatAnswerLimit = 0; // 作答次数限制
  repeatAnswerLimit = 100; // 作答次数限制 暂时默认无限制
  screenshotCheck = 2; //是否防截屏 012
  screenshotCheckLimit = 2; //截屏次数限制
  isMarkDimensionScoreExam = 1; //是否开启小维度打分 12
  questionRandomSort = 2; // 是否题目乱序
  questionRandomSortRange = [1, 1]; // 题目乱序配置 从1记
  // // 防作弊限制
  // MobileJoinCountCheck     EnumBoolOption `json:"mobileJoinCountCheck"`     // 是否校验移动端跳出次数
  removeMaskTip = 2; //摘口罩提示
  // // 相机设置
  beautyModel = 2; // 是否开启美颜
  // // 其他设置
  testExamId = 0; // 模拟练习面试id
  timeLimitExam = 86400; //考试时长限制（秒）默认24h
  repeatAnswerDayLimitSwitch = true;
  repeatAnswerDayLimit = 1;

  //***********关注项配置 */
  headerOptions: HeaderOption[] = [new HeaderOption()];
  normalOptionErrorNumber = 5; //重点关注项 限制淘汰数量
  needCv = 0; //有无工单
  timeLimitExamType = 1;
  closeQuestionVideo = 2; //关闭答题端题目视频

  encodeCandidateInfo = 2; //候选人导出加密 1加密2不加密
  encodeTypeConnectCode = 0; //0展示 1不展示  编号
  encodeTypeBaseInfo = 0; //0展示 1不展示 2加密展示  个人信息
  encodeTypeOtherInfo = 0; // 0展示 1不展示   其他字段

  //所有默认配置项
  public static getAllOptionList() {
    return request.post("aiExam/exam3/defaultHeaderOptions", {}).then(resp => {
      if (resp.data.code === 0) {
        const list: HeaderOption[] = [];
        resp.data.data?.headerOptions?.forEach((item: any) => {
          list.push(new HeaderOption(item).assign(item));
        });
        return list;
      } else {
        return [];
      }
    });
  }

  //新建面试
  static create(param: any) {
    param.userId = Auth.userId;
    return request.post("aiExam/exam3/create", param).then(resp => {
      return resp;
    });
  }
  static update(param: any) {
    return request.post("aiExam/exam3/update", param).then(resp => {
      return resp;
    });
  }
  static updateName(param: any) {
    return request.post("aiExam/exam3/updateName", param).then(resp => {
      return resp;
    });
  }
  //获取文化题信息
  static getQuestion(param: any) {
    return request.post("aiExam/question3/singleChoice", param).then(resp => {
      return resp;
    });
  }
}

export class Video extends Model {
  questionId = 0;
  descTextOnly = "";
  isExamUsed = 0;
  checked = false;
  editing = false;

  static getList(param = {}) {
    return request.post("aiExam/question3/video", param).then(resp => {
      return resp;
    });
  }

  static create(p: any) {
    return request.post("aiExam/question3/videoCreate", p).then(resp => {
      return resp;
    });
  }

  static update() {
    return request.post("aiExam/question3/videoUpdate", {}).then(resp => {
      return resp;
    });
  }

  static delete(p: any) {
    return request.post("aiExam/question3/videoDelete", p).then(resp => {
      return resp;
    });
  }
}

//配置项文案
export class AllOptionText {
  defaultOp = {
    抑郁自杀倾向: {
      sub: "通过量表评估候选人是否有抑郁自杀风险",
      subAll: "通过专业心理测评量表对候选人是否有抑郁自杀风险进行评估",
      way: "心理测评量表",
      resList: [
        {
          title: "风险低",
          text: "正常状态",
          status: 0
        },
        {
          title: "风险高",
          text: "候选人在抑郁自杀方面表现出高倾向",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加测评",
          status: 1
        }
      ]
    },
    暴力反社会倾向: {
      sub: "通过量表评估候选人是否有暴力反社会风险",
      subAll: "通过专业心理测评量表对候选人是否有暴力、反社会风险进行评估",
      way: "心理测评量表",
      resList: [
        {
          title: "风险低",
          text: "正常状态",
          status: 0
        },
        {
          title: "风险高",
          text: "候选人在抑郁自杀方面表现出高倾向",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加测评",
          status: 1
        }
      ]
    },
    心理健康测量: {
      sub:
        "用于评估个体心理健康状况的工具，主要测量候选人的抑郁倾向、暴力倾向以及健康适应性三个维度，共33个题目。",
      subAll:
        "用于评估个体心理健康状况的工具，主要测量候选人的抑郁倾向、暴力倾向以及健康适应性三个维度，共33个题目。",
      way: "心理测评量表",
      resList: [
        {
          title: "风险低",
          text: "候选人心理健康表现出低风险水平",
          status: 0
        },
        {
          title: "风险中等",
          text: "候选人心理健康表现出中风险水平",
          status: 0
        },
        {
          title: "风险高",
          text: "候选人心理健康表现出高风险水平",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加评测",
          status: 1
        }
      ]
    },
    金融黑名单: {
      sub: "查询用户的金融风险状况，包括逾期、欺诈风险、关联风险等",
      subAll:
        "在候选人确定授权后，查询身份证及手机号维度用户的金融风险状况，包括逾期（M1-M6+)，欺诈风险，关联风险等。",
      way: "信息查询",
      resList: [
        {
          title: "未查询到金融黑名单",
          text: "未查询到金融黑名单",
          status: 0
        },
        {
          title: "查询到金融黑名单",
          text:
            "查询到候选人有以下情况：存在欺诈/逾期状态、最近12个月有严重逾期、最近6个月有机构确认为黑名单",
          status: 1
        },
        {
          title: "身份信息异常无法查询",
          text: "候选人身份无法确认，可能姓名、身份证不一致",
          status: 1
        },
        {
          title: "未确认授权",
          text: "候选人未确认授权",
          status: 1
        }
      ]
    },
    负面社会安全记录: {
      sub: "查询是否存在公安不良记录，包括前科、涉毒等",
      subAll:
        "在候选人确定授权后，通过姓名、身份证号查询是否存在公安不良记录，包括前科、涉毒等",
      way: "信息查询",
      resList: [
        {
          title: "未查询到负面社会安全记录",
          text: "正常状态，候选人无负面记录",
          status: 0
        },
        {
          title: "查询到负面社会安全记录",
          text: "查询到候选人有以下情况：存在欺诈/查询到候选人有相关负面记录",
          status: 1
        },
        {
          title: "身份信息异常无法查询",
          text: "候选人身份无法确认，可能姓名、身份证不一致",
          status: 1
        },
        {
          title: "未确认授权",
          text: "候选人未确认授权",
          status: 1
        }
      ]
    },
    身份认证: {
      sub: "通过人脸比对，查验候选人是否与身份证身份一致",
      subAll:
        "通过采集候选人姓名、证件信息，与AI面试过程中截取实时面试画像进行人脸比对",
      way: "人脸对比、信息查询",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人身份与证件不一致",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加",
          status: 1
        }
      ]
    },
    人脸识别: {
      sub: "通过人脸比对，查验候选人是否与身份证身份一致",
      subAll:
        "通过采集候选人姓名、证件信息，与AI面试过程中截取实时面试画像进行人脸比对",
      way: "人脸对比",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人身份与证件不一致",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    换人检测: {
      sub: "检测候选人在面试过程中是否有换人答题情况",
      subAll: "通过摄像头持续监控候选人的作答过程，检测是否有换人作答情况",
      way: "人脸对比",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人存在换人作答情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加(包括中途退出)",
          status: 1
        }
      ]
    },
    手机号实名认证: {
      sub: "查验候选人的手机号号主是否为本人",
      subAll: "通过采集候选人姓名、证件信息，查验手机号号主是否为候选人本人",
      way: "信息查询",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人与手机号号主不一致",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加(包括中途退出)",
          status: 1
        }
      ]
    },
    手掌手臂检测: {
      sub: "检测候选人是否存在手指残疾/残缺的情况",
      subAll:
        "通过对候选人手掌手臂照片进行AI识别，检测候选人是否存在手指残疾/残缺的情况",
      way: "拍照检测",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人存在手指残疾或残缺情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    手部综合检测: {
      sub: "检测候选人是否存在手指残疾/残缺的情况",
      subAll:
        "通过让候选人展示手掌及做握拳动作，AI检测候选人的手指：是否足够灵活，能否正常完成指定动作；手指是否存在残疾、残缺情况；手部是否存在大片疤痕或纹身。其中各项支持单独考察",
      way: "视频检测（手部综合检测）",
      edit: false,
      resList: [
        {
          title: "各项检测均为正常状态",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: `<b>手指灵活度</b>：候选人只能握半拳、未完成任何1次握拳动作<br/>
          <b>手指完整度</b>：候选人手指少1个及以上指节、少1个及以上手指、多1个及以上手指、或其他残疾情况<br/>
          <b>手部疤痕纹身</b>：候选人存在明显的疤痕或纹身（大于3平方厘米左右）`,
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    纹身疤痕检测: {
      sub: "检测候选人四肢是否存在残疾、疤痕纹身情况",
      subAll:
        "通过对候选人四肢进行AI识别，检测候选人是否存在残疾/疤痕/纹身的情况",
      way: "视频检测",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人四肢存在残疾/疤痕/纹身情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    四肢检测: {
      sub: "检测候选人四肢是否存在残疾、疤痕纹身情况",
      subAll:
        "通过对候选人四肢进行AI识别，检测候选人是否存在残疾/疤痕/纹身的情况",
      way: "视频检测",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人四肢存在残疾/疤痕/纹身情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    辨色检测: {
      sub: "检测候选人是否存在色盲/色弱情况",
      subAll: "通过选择题检测候选人是否存在色盲/色弱的情况",
      way: "选择题",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人存在色盲/色弱情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    认知能力: {
      sub: "通过打气球游戏检测候选人认知能力是否正常",
      subAll: "通过打气球小游戏，检测候选人的认知能力是否正常",
      way: "游戏测评",
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人认知能力较差或未认真作答",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    沟通表达: {
      sub: "通过视频题对候选人语速、磕巴程度、普通话是否标准进行综合考察评估",
      subAll:
        "通过视频题对候选人语速、磕巴程度、普通话是否标准进行综合考察评估",
      way: "视频题",
      edit: true,
      resList: [
        {
          title: "通过",
          text: "候选人口齿清晰、普通话标准、语速适中、音量适中",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人存在口音严重，语音语调怪异，口齿不清等情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加(包括中途退出)",
          status: 1
        }
      ]
    },
    形象素质: {
      sub: "通过视频题对候选人语速、磕巴程度、普通话是否标准进行综合考察评估",
      subAll:
        "通过视频题对候选人语速、磕巴程度、普通话是否标准进行综合考察评估",
      way: "视频题",
      edit: true,
      resList: [
        {
          title: "通过",
          text: "候选人形象正常、五官端正，仪容仪表合格",
          status: 0
        },
        {
          title: "未通过",
          text:
            "候选人可能有大面积纹身或面部有纹身、兔唇、畸形、残疾、斜视等情况",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加(包括中途退出)",
          status: 1
        }
      ]
    },
    //todo
    通用视频视为自定义: {
      sub: "通过视频题对候选人某些素质进行综合考察评估（简介）",
      subAll: "通过视频题对候选人进行综合考察评估（详情）",
      way: "视频题",
      edit: true,
      resList: [
        {
          title: "通过",
          text: "候选人得分符合要求",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人得分未达到岗位要求",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加(包括中途退出)",
          status: 1
        }
      ]
    },
    岗位要求: {
      sub: "在信息登记页对候选人岗位意向进行收集，可自由设定评估规则",
      subAll: "在信息登记页对候选人岗位意向进行收集，可自由设定评估规则",
      way: "登记信息-多选",
      question: "请选择你可接受的岗位",
      rule:
        "共有7个选项：无尘服、夜班、长期站立、穿戴橡胶手套、高温作业、噪音环境、特殊气味。当候选人不接受其中某项，则该项考察为未通过，可选择重点考察内容加入关注项。",
      // edit: true,
      resList: [
        {
          title: "通过",
          text: "候选人在选择时命中通过规则，符合考察要求",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人在选择时未命中通过规则，不符合考察要求",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试（包括中途退出）",
          status: 1
        }
      ]
    },
    年龄要求: {
      sub: "通过身份证号自动计算候选人年龄，可设置范围",
      subAll: "通过身份证号自动计算候选人年龄，可设置范围",
      way: "登记信息-身份证号（自动计算）",
      question: "身份证号",
      rule: "年龄超过限定范围，则年龄不符合要求",
      edit: true,
      required: true,
      resList: [
        {
          title: "通过",
          text: "正常状态",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人年龄超过允许范围",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    },
    // 民族要求: {
    //   sub: "在信息登记页对候选人民族信息进行收集，是否有特殊要求",
    //   subAll: "在信息登记页对候选人民族信息进行收集，是否有特殊要求",
    //   way: "登记信息-单选",
    //   question: "请选择你的民族",
    //   rule: "若选择以下内容则此考察项未通过：藏族、维吾尔族、黎族、回族。",
    //   // edit: true,
    //   resList: [
    //     {
    //       title: "通过",
    //       text: "候选人在选择时命中通过规则，符合考察要求",
    //       status: 0
    //     },
    //     {
    //       title: "未通过",
    //       text: "候选人在选择时命中未通过规则，不符合考察要求",
    //       status: 1
    //     },
    //     {
    //       title: "未作答",
    //       text: "候选人未参加面试(包括中途退出)",
    //       status: 1
    //     }
    //   ]
    // },
    文化考试测试: {
      sub:
        "考察候选人文化水平是否合格，如需自定义文化考试，请联系海纳进行编辑上传",
      subAll:
        "考察候选人文化水平是否合格，如需自定义文化考试，请联系海纳进行编辑上传",
      way: "选择题",
      question: "随机抽取",
      edit: true,
      rule:
        "本考试共10题，满分100分。分别从语文、常识、英语、逻辑、反欺诈类等题目中随机抽取组成试卷。",
      // edit: true,
      resList: [
        {
          title: "通过",
          text: "候选人考试分数≥60分",
          status: 0
        },
        {
          title: "未通过",
          text: "候选人考试分数<60分",
          status: 1
        },
        {
          title: "未作答",
          text: "候选人未参加面试(包括中途退出)",
          status: 1
        }
      ]
    }
  };
  defaultSocialStatus = {
    1: {
      text: "未通过身份验证，无法进行查询",
      status: 1
    },
    2: {
      text: "未查询到相关负面记录",
      status: 0
    },
    3: {
      text: "查询到相关记录",
      status: 1
    },
    4: {
      text: "查询中",
      status: 1
    },
    5: {
      text: "未知原因无法查询",
      status: 1
    },
    102: {
      text: "未授权，无法进行查询",
      status: 1
    }
  };

  get op() {
    if (CompanyConfig.getInstance().backgroundCheckJudgment === 1)
      return Object.assign(this.defaultOp, {
        金融黑名单: {
          sub: "查询用户的金融风险状况，包括逾期、欺诈风险、关联风险等",
          subAll:
            "在候选人确定授权后，查询身份证及手机号维度用户的金融风险状况，包括逾期（M1-M6+)，欺诈风险，关联风险等。",
          way: "信息查询",
          resList: [
            {
              title: "未查询到金融黑名单",
              text: "未查询到金融黑名单",
              status: 0
            },
            {
              title: "未确认授权",
              text: "候选人未确认授权",
              status: 2
            },
            {
              title: "未查询",
              text: "候选人身份无法确认，可能姓名、身份证、手机号不一致",
              status: 2
            },
            {
              title: "查询到金融黑名单",
              text:
                "查询到候选人有以下情况：存在欺诈/逾期状态、最近12个月有严重逾期、最近6个月有机构确认为黑名单",
              status: 1
            }
          ]
        },
        负面社会安全记录: {
          sub: "查询是否存在公安不良记录，包括前科、涉毒等",
          subAll:
            "在候选人确定授权后，通过姓名、身份证号查询是否存在公安不良记录，包括前科、涉毒等",
          way: "信息查询",
          resList: [
            {
              title: "未查询到负面社会安全记录",
              text: "正常状态，候选人无负面记录",
              status: 0
            },
            {
              title: "未确认授权",
              text: "候选人未确认授权",
              status: 2
            },
            {
              title: "未查询",
              text: "候选人身份无法确认，可能姓名、身份证、手机号不一致",
              status: 2
            },
            {
              title: "查询到负面社会安全记录",
              text:
                "查询到候选人有以下情况：存在欺诈/查询到候选人有相关负面记录",
              status: 1
            }
          ]
        }
      });

    return this.defaultOp;
  }

  get socialStatus() {
    if (CompanyConfig.getInstance().backgroundCheckJudgment === 1)
      return Object.assign(this.defaultOp, {
        1: {
          text: "未进行查询",
          status: 2
        },
        2: {
          text: "未查询到相关负面记录",
          status: 0
        },
        3: {
          text: "查询到相关记录",
          status: 1
        },
        4: {
          text: "查询中",
          status: 1
        },
        5: {
          text: "未知原因无法查询",
          status: 2
        },
        102: {
          text: "未授权，无法进行查询",
          status: 2
        }
      });

    return this.defaultSocialStatus;
  }
}
